module.exports = __webpack_public_path__ + "static/img/certain-button.82c8814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certain-button.png
// module id = qzp5
// module chunks = 0